export default __webpack_public_path__ + "static/media/upload_doc.f4bda3e4.svg";